import React from 'react'
import WorkerCalDeletedDisplay from '../components/workerCalles/WorkerCalDeletedDisplay'



export default function WorkerCallDelete() {
  return (
    <div className="layout-body">
    <WorkerCalDeletedDisplay />
    </div>
  )
}
